import { buildPanelItem } from "../helpers/buildPanelItem";
import { Label } from "../components/Label";

export const scoresFaceMatchPanel = [
  buildPanelItem(
    "1",
    Label({ label: "score", type: "string" }),
    "The face matching score. It ranges from 0 to 1.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "threshold", type: "string" }),
    "The face matching threshold above which a score is considered a matching (accepted) score.",
  ),
  buildPanelItem(
    "3",
    Label({ label: "match_with", type: "string" }),
    'This specifies the source of the biometric information used for matching. By order of source confidence, possible values are "saffe_network", "onboarding", or "id_image". The source "saffe_network" is our anonymized biometric antifraud network, to which only carefully curated anonymous identities are added. The source "onboarding" corresponds to the users registered by the partner in its workspace. At last, the source "id_image" corresponds to the facial image contained in the ID picture when such picture is available. That is, when "ID capture" is set to ON in the Integration page. It is important to note that the source "id_image" is not reliable given the possibility of the fraudster to manipulate the ID before it is photographed. That is why "id_image" is the lowest ranking biometric information source used for matching.',
  ),
  buildPanelItem(
    "4",
    Label({ label: "status", type: "string" }),
    'Matching status can be "matched", "not_matched", or "not_available". The statuses "matched" and "not_matched" derive directly from the face matching score and threshold. The status "not_available" derives from the absence of the user in any of the biometric information sources considered (see "scores.face_match.match_with" parameter above).',
  ),
];
